import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirect permanente: /tarefas (rota antiga) → /pipeline/tarefas (Portal Vega Bloco 1, DEC-060). */
export const Route = createFileRoute('/tarefas')({
  beforeLoad: () => {
    throw redirect({ to: '/pipeline/tarefas' });
  },
});
